import React, { useState, useEffect, useContext } from "react";
import Modal from "react-bootstrap/Modal";
import { API_URL } from "../../components/api";
import EditOrder from "./InvoiceDetail";
import PrintInvoice from "./PrintInvoice";
import EditInvoice from "./EditInvoice";
import Button from "react-bootstrap/Button";
import EditingInvoices from "./EditingInvoice";
import TextField from "@mui/material/TextField";
import "./SystemInvoice.css";

import {
  DataGrid,
  GridToolbarContainer,
  GridToolbarColumnsButton,
  GridToolbarFilterButton,
  GridToolbarExport,
} from "@mui/x-data-grid";

import AuthContext from "../../context/AuthContext";
import LanguageContext from "../../context/LanguageContext";

// For API Requests
import axios from "axios";
import ExcelSVG from "./ExcelSVG.svg";
import FilterSVG from "./FilterSVG.svg";
import * as XLSX from "xlsx";

function InvoiceTable() {
  const [data, setData] = useState([]);
  const [showdetails, setShowDetails] = useState(false);
  const [showedit, setShowEdit] = useState(false);
  const [showprint, setShowPrint] = useState(false);
  const [showCancel, setShowCancel] = useState(false);
  const [showEditInvoice, setShowEditInvoice] = useState(false); //New
  const [reason, setReason] = useState("");
  const [cancelError, setCancelError] = useState("");
  const [canAdjust, setCanAdjust] = useState(false);
  const [receiptBlocked, setReceiptBlocked] = useState(false);
  const [paymentAction, setPaymentAction] = useState("");
  const [clientQuery, setClientQuery] = useState("");
  const [clientResults, setClientResults] = useState([]);
  const [targetClient, setTargetClient] = useState(null);
  const [targetInvoices, setTargetInvoices] = useState([]);
  const [tickedInvoices, setTickedInvoices] = useState([]);
  const [invoiceAction, setInvoiceAction] = useState("cancel");
  const [invoiceInfo, setInvoiceInfo] = useState(null);

  const [showStatusPrompt, setShowStatusPrompt] = useState(false);
  const [newStatus, setNewStatus] = useState("");
  const [invoice, setInvoice] = useState("");

  const [selectedRow, setSelectedRow] = useState(null);
  const [searchQuery, setSearchQuery] = useState("");
  const [loading, setLoading] = useState(true);
  const [message, setMessage] = useState(null);

  const [selectedInvoiceId, setSelectedInvoiceId] = useState(null);
  const [selectedEditInvoice, setSelectedEditInvoice] = useState(null);

  const [filters, setFilters] = useState({
    status: "",
    fullname_en: "",
    date: "",
    description: "",
    total_amount: "",
    discount: "",
    totalMinusDiscount: "",
    initiator: "",
  });
  const [showFilterModal, setShowFilterModal] = useState(false);
  const [gridFilterModel, setGridFilterModel] = useState({
    items: [],
  });

  const [searchInput, setSearchInput] = useState(""); // To capture search input

  // NEW: State to track column visibility
  const [columnVisibilityModel, setColumnVisibilityModel] = useState({});
  const [searchFilterTimeout, setSearchFilterTimeout] = useState(null);

  const { user } = useContext(AuthContext);
  const { language, t } = useContext(LanguageContext);
  const authTokens = JSON.parse(localStorage.getItem("authTokens"));

  const handleshowDetails = () => setShowDetails(true);
  const handlecloseDetails = () => setShowDetails(false);
  const handleshowPrint = () => setShowPrint(true);
  const handleclosePrint = () => setShowPrint(false);
  const handleshowEdit = () => setShowEdit(true);
  const handlecloseEdit = () => setShowEdit(false);

  const handleShowEditInvoice = (invoice) => {
    setSelectedEditInvoice(invoice);
    setShowEditInvoice(true);
  };

  const handleCloseEditInvoice = () => {
    setShowEditInvoice(false);
    setSelectedEditInvoice(null);
  };

  const [dealerDetails, setDealerDetails] = useState({
    order_id: 0,
    invoice_id: 0,
  });

  const updateDealerDetails = (details) => {
    setDealerDetails(details);
  };
  const fetchData = async () => {
    try {
      const response = await axios.get(
        `${API_URL}/inventory/invoices/system/`,
        {
          headers: {
            Authorization: `Bearer ${authTokens.access}`,
          },
          params: {
            username: user.username,
          },
        }
      );

      if (response.status === 200) {
        setData(response.data.reverse());
        console.log(response.data);
      }
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
    }
  };
  useEffect(() => {
    fetchData();
  }, [user.username, authTokens.access]);

  const columns = [
    {
      field: "status",
      headerName: "Status",
      flex: 2,
      minWidth: 120,
      renderCell: (params) => (
        <div
          style={{ cursor: "pointer" }}
          onClick={() => handleStatusCellClick(params)}
        >
          {params.value}
        </div>
      ),
    },
    { field: "fullname_en", headerName: "Name", flex: 2, minWidth: 150 },
    {
      field: "date",
      headerName: "Date",
      flex: 2,
      minWidth: 200,
      valueFormatter: (params) => {
        const date = new Date(params.value);
        return date.toLocaleString("en-GB", {
          day: "2-digit",
          month: "2-digit",
          year: "numeric",
          hour: "2-digit",
          minute: "2-digit",
          hour12: true,
        });
      },
    },
    {
      field: "description",
      headerName: "Description",
      flex: 4,
      minWidth: 360,
      renderCell: (params) => (
        <div className="system-invoice-description-cell">
          {params.value || "-"}
        </div>
      ),
    },
    { field: "total_amount", headerName: "Total", flex: 2, minWidth: 100 },
    { field: "discount", headerName: "Discount", flex: 2, minWidth: 100 },
    {
      field: "totalMinusDiscount",
      headerName: "Total - Discount",
      flex: 2,
      minWidth: 100,
      valueGetter: (params) => {
        const total = params.row.total_amount || 0;
        const discount = params.row.discount || 0;
        return total - discount;
      },
    },
    { field: "initiator", headerName: "Initiator", flex: 2, minWidth: 100 },
    {
      field: "actions",
      headerName: "Actions",
      minWidth: 300,
      flex: 2,
      renderCell: (params) => (
        <div className="system-invoice-actions">
          <button
            type="button"
            className="edit-client system-invoice-action-button"
            onClick={() => handleOpenModal(params.row.invoice_id)}
          >
            Cancel
          </button>
          <button
            type="button"
            className="edit-client system-invoice-action-button"
            onClick={() => handleShowEditInvoice(params.row)}
          >
            Edit Discount
          </button>
        </div>
      ),
    },
  ];

  const showMessage = (message, type = "success") => {
    setMessage({ text: message, type });

    // Clear the message after 5 seconds
    setTimeout(() => {
      setMessage(null);
    }, 5000);
  };

  const getRowId = (row) => row.invoice_id;

  // Create a delayed search filter function
  const delaySearchFilter = (input) => {
    setSearchQuery(input);
  };

  useEffect(() => {
    // Save "searchCollector" value before clearing other session storage items
    const searchValue = sessionStorage.getItem("searchSystemInvoice");

    // Clear all session storage items except "searchCollector"
    Object.keys(sessionStorage).forEach((key) => {
      if (key !== "searchSystemInvoice") {
        sessionStorage.removeItem(key);
      }
    });

    // Restore "searchCollector" value if needed
    if (searchValue) {
      sessionStorage.setItem("searchSystemInvoice", searchValue);
      setSearchQuery(searchValue);
    }
  }, []);

  const handleSearchChange = (event) => {
    const query = event.target.value;
    setSearchInput(query);
    sessionStorage.setItem("searchSystemInvoice", query);

    if (searchFilterTimeout) {
      clearTimeout(searchFilterTimeout);
    }

    const newTimeout = setTimeout(() => {
      delaySearchFilter(query);
    }, 100);
    setSearchFilterTimeout(newTimeout);
  };

  const handleStatusCellClick = (params) => {
    if (params.row.status === "Pending") {
      setNewStatus("Done");
      setSelectedRow(params.row);
      setInvoice(params.row.invoice_id); // Set the invoice ID when the status cell is clicked
      setShowStatusPrompt(true);
    } else {
      setNewStatus(params.row.status || "Done"); // Set default value if status is not present
      setShowStatusPrompt(true);
      setSelectedRow(params.row);
      setInvoice(params.row.invoice_id); // Set the invoice ID when the status cell is clicked
    }
  };

  const handleStatusPromptClose = () => {
    setNewStatus("");
    setShowStatusPrompt(false);
    setSelectedRow(null);
  };

  const handleSubmit = async () => {
    try {
      const response = await axios.post(
        `${API_URL}/inventory/invoices/status/`,
        {
          status: newStatus,
          invoice: invoice,
          userdealer: user.username,
        },
        {
          headers: {
            Authorization: `Bearer ${authTokens.access}`,
          },
        }
      );

      console.log(response);
      showMessage("Status changed!", "success");
      // Fetch updated data
      const updatedData = await axios.get(
        `${API_URL}/inventory/invoices/system/`,
        {
          headers: {
            Authorization: `Bearer ${authTokens.access}`,
          },
          params: {
            username: user.username,
          },
        }
      );
      setData(updatedData.data.reverse());
    } catch (error) {
      console.log(error);
      showMessage("Edit failed!", "danger");
    }
  };
  const handleOpenModal = (receiptId) => {
    setSelectedInvoiceId(receiptId);
    setShowCancel(true);
  };

  const handleCloseModal = () => {
    setShowCancel(false);
    setSelectedInvoiceId(null);
    setCancelError("");
    setReceiptBlocked(false);
    setPaymentAction("");
    setClientQuery("");
    setClientResults([]);
    setTargetClient(null);
    setTargetInvoices([]);
    setTickedInvoices([]);
    setInvoiceAction("cancel");
    setInvoiceInfo(null);
  };

  useEffect(() => {
    let active = true;
    axios
      .get(`${API_URL}/inventory/receipt/reassign/`, {
        headers: { Authorization: `Bearer ${authTokens.access}` },
      })
      .then(() => {
        if (active) setCanAdjust(true);
      })
      .catch(() => {
        if (active) setCanAdjust(false);
      });
    return () => {
      active = false;
    };
  }, []);

  const adjustGet = (params) =>
    axios.get(`${API_URL}/inventory/receipt/reassign/`, {
      headers: { Authorization: `Bearer ${authTokens.access}` },
      params,
    });

  const searchClients = async (value) => {
    setClientQuery(value);
    setTargetClient(null);
    setTargetInvoices([]);
    setTickedInvoices([]);
    if (value.trim().length < 2) {
      setClientResults([]);
      return;
    }
    try {
      const response = await adjustGet({ q: value.trim() });
      setClientResults(response.data.clients || []);
    } catch (error) {
      setClientResults([]);
    }
  };

  const chooseClient = async (client) => {
    setTargetClient(client);
    setClientResults([]);
    setClientQuery(`${client.client_id} - ${client.name}`);
    setTickedInvoices([]);
    try {
      const response = await adjustGet({ client_id: client.client_id });
      setTargetInvoices(response.data.invoices || []);
    } catch (error) {
      setTargetInvoices([]);
    }
  };

  const toggleInvoice = (invoiceId) => {
    setTickedInvoices((current) =>
      current.includes(invoiceId)
        ? current.filter((id) => id !== invoiceId)
        : [...current, invoiceId]
    );
  };

  const allFromCredit = Boolean(invoiceInfo && invoiceInfo.all_from_credit);
  const needsClient = paymentAction === "reassign" && !allFromCredit;
  const confirmDisabled = () =>
    receiptBlocked &&
    canAdjust &&
    (!paymentAction ||
      (needsClient && !targetClient) ||
      (invoiceAction === "keep" &&
        (paymentAction === "credit" || allFromCredit)));
  const money = (v) => Number(v || 0).toFixed(2);
  const whatWillHappen = () => {
    if (!receiptBlocked || !invoiceInfo || !paymentAction) return "";
    const ar = language === "ar";
    const name = invoiceInfo.client_name;
    const amt = money(invoiceInfo.amount);
    const cash = money(invoiceInfo.cash_total);
    const other = targetClient
      ? targetClient.name
      : ar
        ? "الزبون الآخر"
        : "the other client";
    const drawers = ar ? " الأدراج لا تتغير." : " Drawers don't change.";
    const cancelLine = ar
      ? `تُلغى الفاتورة: ${name} −${amt}.`
      : `Invoice cancelled: ${name} −${amt}.`;
    const keepLine = ar
      ? `تعود الفاتورة معلقة، ${name} ما زال مديناً بها.`
      : `Invoice back to Pending, ${name} still owes it.`;
    if (allFromCredit) {
      if (invoiceAction === "keep") {
        return ar
          ? "دفعها من رصيده. لا شيء يتغير."
          : "He paid this from his own credit. Nothing to change.";
      }
      const bill =
        paymentAction === "reassign"
          ? ar
            ? " فوتر الزبون الآخر كالمعتاد."
            : " Bill the other client as usual."
          : "";
      return (
        (ar
          ? `دفعها من رصيده. ${cancelLine} يعود رصيده.`
          : `He paid this from his own credit. ${cancelLine} His credit is back.`) +
        bill +
        drawers
      );
    }
    if (paymentAction === "credit" && invoiceAction === "keep") {
      return ar ? "لا شيء يتغير." : "Nothing to change.";
    }
    let pay = "";
    if (paymentAction === "credit") {
      pay = ar
        ? `يبقى الإيصال، الـ${cash} تبقى رصيداً لـ${name}.`
        : `Receipt stays, the ${cash} he paid stays as ${name}'s credit.`;
    }
    if (paymentAction === "reassign") {
      pay = ar
        ? `ينتقل الإيصال إلى ${other}: ${name} +${cash}، ${other} −${cash}.`
        : `Receipt moves to ${other}: ${name} +${cash}, ${other} −${cash}.`;
      if (targetClient) {
        let left = Number(invoiceInfo.cash_total || 0);
        const parts = [];
        targetInvoices
          .filter((item) => tickedInvoices.includes(item.invoice_id))
          .sort((a, b) => (a.date || "").localeCompare(b.date || "") || a.invoice_id - b.invoice_id)
          .forEach((item) => {
            const due = Number(item.due || 0);
            const portion = Math.min(left, due);
            left -= portion;
            if (portion <= 0) {
              parts.push(ar ? `#${item.invoice_id} لا يصله شيء` : `#${item.invoice_id} gets nothing`);
            } else if (portion < due) {
              parts.push(ar ? `${money(portion)} على #${item.invoice_id} (يبقى ${money(due - portion)})` : `${money(portion)} on #${item.invoice_id} (${money(due - portion)} still due)`);
            } else {
              parts.push(ar ? `#${item.invoice_id} يُسدَّد (${money(portion)})` : `#${item.invoice_id} settled (${money(portion)})`);
            }
          });
        if (left > 0) {
          parts.push(ar ? `${money(left)} تبقى رصيداً له` : `${money(left)} stays as his credit`);
        }
        if (parts.length) {
          pay += (ar ? " الأقدم أولاً: " : " Oldest first: ") + parts.join(ar ? "، " : ", ") + ".";
        }
      }
    }
    if (paymentAction === "void") {
      pay = ar
        ? `يُلغى الإيصال: ${name} +${cash}.`
        : `Receipt voided: ${name} +${cash}.`;
    }
    return pay + " " + (invoiceAction === "keep" ? keepLine : cancelLine) + drawers;
  };

  const handleConfirm = async () => {
    try {
      const response = await axios.post(
        `${API_URL}/inventory/invoices/cancel/`,
        {
          invoice_id: selectedInvoiceId,
          username: user.username,
          reason: reason,
          ...(receiptBlocked && canAdjust && paymentAction
            ? {
                payment_action: paymentAction,
                invoice_action: invoiceAction,
                client_id: targetClient ? targetClient.client_id : null,
                invoice_ids: tickedInvoices,
              }
            : {}),
        },
        {
          headers: {
            Authorization: `Bearer ${authTokens.access}`,
          },
        }
      );

      if (response.status === 200) {
        const kept =
          response.data && response.data.message === "Payment fixed, invoice kept pending";
        showMessage(
          language === "ar"
            ? kept
              ? "تم تصحيح الدفعة والفاتورة باقية معلقة"
              : "تم إلغاء الفاتورة"
            : kept
              ? "Payment fixed, invoice kept pending"
              : "Invoice cancelled"
        );
        setCancelError("");
        handleCloseModal();
        fetchData();
      }
    } catch (error) {
      console.error("Error confirming receipt:", error);
      const cancelCode = error?.response?.data?.code;
      if (cancelCode === "receipt_attached" && canAdjust) {
        try {
          const info = await adjustGet({ invoice_id: selectedInvoiceId });
          setInvoiceInfo(info.data);
        } catch (infoError) {
          setInvoiceInfo(null);
        }
        setReceiptBlocked(true);
        setCancelError("");
        return;
      }
      setCancelError(
        language === "ar"
          ? t(
              cancelCode === "receipt_attached"
                ? "invoiceList.cancelReceiptFirst"
                : cancelCode === "returned_device_missing"
                  ? "invoiceList.cancelDeviceMissing"
                  : "invoiceList.cancelFailed"
            )
          : error?.response?.data?.message ||
              "Could not cancel this invoice. Please try again."
      );
    }
  };
  const handleStatusConfirmation = () => {
    console.log("Invoice ID:", selectedRow.invoice_id);
    console.log("New Status:", newStatus);
    // Perform any additional actions here (e.g., API call, state update)
    handleSubmit();
    handleStatusPromptClose();
  };

  // IMPROVED: Combined filtering logic that works for both display AND export
  const filteredRows = data.filter((row) => {
    // Apply search query filter
    const searchMatch = searchQuery
      .split(" ")
      .every((word) =>
        Object.values(row).some((value) =>
          String(value).toLowerCase().includes(word.toLowerCase().trim())
        )
      );

    // Apply modal filters
    const modalFilterMatch = Object.keys(filters).every((key) => {
      if (!filters[key]) return true;

      if (key === "connectivity_dependent") {
        const filterValue = filters[key].toLowerCase();
        if (row.connectivity === "Fiber") {
          return (row.code || "").toLowerCase().includes(filterValue);
        } else if (row.connectivity === "Wireless") {
          return (row.name || "").toLowerCase().includes(filterValue);
        }
        return false;
      }

      const rowValue = String(row[key] || "").toLowerCase();
      const filterValue = String(filters[key]).toLowerCase();
      return rowValue.includes(filterValue);
    });

    // Apply DataGrid filters
    const gridFilterMatch = gridFilterModel.items.every((filterItem) => {
      if (!filterItem.value) return true;

      const cellValue = row[filterItem.field];
      const filterValue = filterItem.value;

      switch (filterItem.operator) {
        case "contains":
          return String(cellValue || "")
            .toLowerCase()
            .includes(String(filterValue).toLowerCase());
        case "equals":
          return String(cellValue || "") === String(filterValue);
        case "startsWith":
          return String(cellValue || "")
            .toLowerCase()
            .startsWith(String(filterValue).toLowerCase());
        case "endsWith":
          return String(cellValue || "")
            .toLowerCase()
            .endsWith(String(filterValue).toLowerCase());
        default:
          return true;
      }
    });

    return searchMatch && modalFilterMatch && gridFilterMatch;
  });

  const handleFilterChange = (field, value) => {
    setFilters((prevFilters) => ({
      ...prevFilters,
      [field]: value,
    }));
  };

  const columnHeaders = {
    status: "Status",
    fullname_en: "Full Name",
    date: "Date",
    description: "Description",
    total_amount: "Total",
    discount: "Discount",
    totalMinusDiscount: "Total - Discount",
  };

  // Format date fields properly for export — e.g. "21/02/2025 10:25:52 AM"
  const formatDateForExport = (dateValue) => {
    if (!dateValue) return "";
    const date = new Date(dateValue);

    // Format as DD/MM/YYYY HH:MM:SS AM/PM
    const formattedDate = date.toLocaleString("en-GB", {
      day: "2-digit",
      month: "2-digit",
      year: "numeric",
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit",
      hour12: true,
    });

    // Ensure consistent spacing before AM/PM
    return formattedDate.replace(" am", " AM").replace(" pm", " PM");
  };

  // Corrected: Transform rows respecting column visibility
  const transformRowsForExport = (rows) => {
    return rows.map((row) => {
      const transformedRow = {};

      Object.keys(columnHeaders).forEach((field) => {
        // Only export if column is visible
        if (columnVisibilityModel[field] !== false) {
          const headerName = columnHeaders[field];

          // Only date needs formatting
          if (field === "date") {
            transformedRow[headerName] = formatDateForExport(row[field]);
          } else {
            // Default: use the value or empty string
            transformedRow[headerName] = row[field] ?? "";
          }
        }
      });

      return transformedRow;
    });
  };

  // IMPROVED: Export function that uses the already-filtered rows
  const handleExportToExcel = () => {
    console.log("Exporting data...");
    console.log("Total data rows:", data.length);
    console.log("Filtered rows:", filteredRows.length);
    console.log("Active filters:", {
      search: searchQuery,
      modalFilters: filters,
      gridFilters: gridFilterModel.items,
    });
    console.log("Column visibility:", columnVisibilityModel);

    // Always use filteredRows which has ALL filters applied
    const transformedRows = transformRowsForExport(filteredRows);

    console.log("Rows to export:", transformedRows.length);

    const worksheet = XLSX.utils.json_to_sheet(transformedRows);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "System Invoice");
    XLSX.writeFile(workbook, "System Invoice.xlsx");
  };

  const [isPressed, setIsPressed] = useState(false);

  const handleExportClick = () => {
    setIsPressed(true);
    handleExportToExcel();
    setTimeout(() => {
      setIsPressed(false);
    }, 200);
  };

  const CustomToolbar = () => (
    <GridToolbarContainer>
      <GridToolbarColumnsButton />
      <Button
        onClick={() => setShowFilterModal(true)}
        variant="outline-primary"
        style={{
          border: "none",
        }}
      >
        <img
          src={FilterSVG}
          alt="Filter Icon"
          style={{
            color: "white",
            width: "18px",
            marginRight: "8px",
            filter: "invert(0)", // keep black icon
          }}
        />
        Filter
      </Button>
      {/*<GridToolbarFilterButton />*/}
      <GridToolbarExport />
      <Button
        onClick={handleExportClick}
        variant="outline-success"
        style={{
          display: "flex",
          alignItems: "center",
          padding: "5px 10px",
          fontSize: "14px",
          border: "none",
          backgroundColor: isPressed ? "white" : "transparent",
          color: isPressed ? "black" : "#007bff",
          cursor: "pointer",
        }}
      >
        <img
          src={ExcelSVG}
          alt="Excel Icon"
          style={{
            width: "20px",
            marginRight: "8px",
            filter: isPressed ? "invert(0)" : "invert(1)",
          }}
        />
        Excel
      </Button>
    </GridToolbarContainer>
  );

  return (
    <div className="ClientTable">
      <style>{`
        .MuiDataGrid-panelWrapper {
          background: #122632 !important;
        }
      `}</style>
      <input
        type="text"
        placeholder="Search..."
        value={searchInput}
        onChange={handleSearchChange}
        className="search-client"
      />
      {!loading && data.length > 0 && (
        <div style={{ height: 520, width: "100%" }}>
          <DataGrid
            rows={filteredRows}
            columns={columns}
            getRowId={getRowId}
            filterModel={gridFilterModel}
            onFilterModelChange={(newModel) => setGridFilterModel(newModel)}
            columnVisibilityModel={columnVisibilityModel}
            onColumnVisibilityModelChange={(newModel) =>
              setColumnVisibilityModel(newModel)
            }
            components={{
              Toolbar: CustomToolbar,
            }}
            rowHeight={110}
            rowsPerPageOptions={[10, 100, 1000]}
            pagination
            disableSelectionOnClick
          />
        </div>
      )}
      <Modal
        show={showdetails}
        onHide={handlecloseDetails}
        className="modal-lg"
      >
        <Modal.Header closeButton>
          <Modal.Title>Details</Modal.Title>
        </Modal.Header>
        <EditOrder
          invoice_id={dealerDetails.invoice_id}
          order_id={dealerDetails.order_id}
        />
      </Modal>
      <Modal show={showedit} onHide={handlecloseEdit} className="modal-lg">
        <Modal.Header closeButton>
          <Modal.Title>Edit</Modal.Title>
        </Modal.Header>
        <EditInvoice
          invoice_id={dealerDetails.invoice_id}
          order_id={dealerDetails.order_id}
        />
      </Modal>
      <Modal show={showprint} onHide={handleclosePrint} className="modal-lg">
        <Modal.Header closeButton>
          <Modal.Title>Print</Modal.Title>
        </Modal.Header>
        <PrintInvoice
          invoice_id={dealerDetails.invoice_id}
          order_id={dealerDetails.order_id}
          data={data.filter(
            (item) => item.invoice_id === dealerDetails.invoice_id
          )}
          data1={data}
        />
      </Modal>

      {/*New Modal */}
      <Modal
        show={showEditInvoice}
        onHide={handleCloseEditInvoice}
        className="modal-lg system-invoice-modal"
      >
        <Modal.Header closeButton>
          <Modal.Title>Edit Discount</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {selectedEditInvoice && (
            <EditingInvoices
              invoice={selectedEditInvoice}
              onClose={handleCloseEditInvoice}
              onSaved={fetchData}
            />
          )}
        </Modal.Body>
      </Modal>

      <Modal show={showStatusPrompt} onHide={handleStatusPromptClose}>
        <Modal.Header closeButton>
          <Modal.Title>Change Status</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <label htmlFor="newStatus">Select new status:</label>
          <select
            id="newStatus"
            value={newStatus}
            onChange={(e) => setNewStatus(e.target.value)}
            className="form-select"
          >
            <option value="Done">Done</option>
            <option value="Blocked">Blocked</option>
          </select>
        </Modal.Body>
        <Modal.Footer>
          <button
            className="btn btn-secondary"
            onClick={handleStatusPromptClose}
          >
            Cancel
          </button>
          <button
            className="btn btn-primary"
            onClick={handleStatusConfirmation}
          >
            Confirm
          </button>
        </Modal.Footer>
      </Modal>
      <Modal show={showCancel} onHide={handleCloseModal}>
        <Modal.Header closeButton>
          <Modal.Title>Cancel Invoice</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          Are you sure you want to cancel this invoice? Please provide a reason.
          <TextField
            autoFocus
            margin="dense"
            fullWidth
            variant="standard"
            value={reason}
            onChange={(e) => setReason(e.target.value)}
          />
          {receiptBlocked && canAdjust && (
            <div className="invoice-cancel-payment">
              <div className="invoice-cancel-question">{language === "ar" ? "من دفع هذه الفاتورة فعلاً؟" : "Who really paid this?"}</div>
              <label className="invoice-cancel-option">
                <input
                  type="radio"
                  name="paymentAction"
                  value="credit"
                  checked={paymentAction === "credit"}
                  onChange={() => setPaymentAction("credit")}
                />{" "}
                {language === "ar" ? "هذا الزبون، المبلغ حقيقي" : "This client, the money is real"}
              </label>
              <label className="invoice-cancel-option">
                <input
                  type="radio"
                  name="paymentAction"
                  value="reassign"
                  checked={paymentAction === "reassign"}
                  onChange={() => setPaymentAction("reassign")}
                />{" "}
                {language === "ar" ? "زبون آخر" : "Another client"}
              </label>
              {needsClient && (
                <div className="invoice-cancel-reassign">
                  <TextField
                    margin="dense"
                    fullWidth
                    variant="standard"
                    placeholder={language === "ar" ? "اسم الزبون أو رقمه" : "Client name or ID"}
                    value={clientQuery}
                    onChange={(e) => searchClients(e.target.value)}
                  />
                  {clientResults.map((client) => (
                    <div
                      key={client.client_id}
                      className="invoice-cancel-client"
                      onClick={() => chooseClient(client)}
                    >
                      {client.client_id} - {client.name}
                    </div>
                  ))}
                  {targetClient && (
                    <div className="invoice-cancel-invoices">
                      <div>{language === "ar" ? "فواتيره المعلقة (ضع إشارة على ما تخصه هذه الدفعة، الباقي يبقى رصيداً)" : "His pending invoices (tick what this payment is for, the rest stays as credit)"}</div>
                      {targetInvoices.length === 0 && <div>{language === "ar" ? "لا فواتير معلقة" : "No pending invoices"}</div>}
                      {targetInvoices.map((item) => (
                        <label
                          key={item.invoice_id}
                          className="invoice-cancel-option"
                        >
                          <input
                            type="checkbox"
                            checked={tickedInvoices.includes(item.invoice_id)}
                            onChange={() => toggleInvoice(item.invoice_id)}
                          />{" "}
                          #{item.invoice_id} · {item.date ? item.date.slice(0, 10) : ""} ·{" "}
                          {item.description} · {language === "ar" ? "المستحق" : "Due"}: {item.due}
                        </label>
                      ))}
                    </div>
                  )}
                </div>
              )}
              <label className="invoice-cancel-option">
                <input
                  type="radio"
                  name="paymentAction"
                  value="void"
                  checked={paymentAction === "void"}
                  onChange={() => setPaymentAction("void")}
                />{" "}
                {language === "ar" ? "لا أحد، الإيصال أُدخل بالخطأ" : "Nobody, the receipt was typed by mistake"}
              </label>
              <div className="invoice-cancel-question">{language === "ar" ? "والفاتورة؟" : "And the invoice?"}</div>
              <label className="invoice-cancel-option">
                <input
                  type="radio"
                  name="invoiceAction"
                  value="cancel"
                  checked={invoiceAction === "cancel"}
                  onChange={() => setInvoiceAction("cancel")}
                />{" "}
                {language === "ar" ? "خطأ، إلغاؤها" : "Wrong, cancel it"}
              </label>
              <label className="invoice-cancel-option">
                <input
                  type="radio"
                  name="invoiceAction"
                  value="keep"
                  checked={invoiceAction === "keep"}
                  onChange={() => setInvoiceAction("keep")}
                />{" "}
                {language === "ar" ? "صحيحة، ما زال مديناً بها" : "Real, he still owes it"}
              </label>
              {whatWillHappen() && (
                <div className="invoice-cancel-summary">
                  <div className="invoice-cancel-question">{language === "ar" ? "ماذا سيحدث" : "What will happen"}</div>
                  {whatWillHappen()}
                </div>
              )}
            </div>
          )}
          {cancelError && (
            <div className="invoice-cancel-error">{cancelError}</div>
          )}
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleCloseModal}>
            Cancel
          </Button>
          <Button
            variant="primary"
            onClick={handleConfirm}
            disabled={confirmDisabled()}
          >
            Confirm
          </Button>
        </Modal.Footer>
      </Modal>
      <Modal show={showFilterModal} onHide={() => setShowFilterModal(false)}>
        <Modal.Header closeButton>
          <Modal.Title>Filters</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {columns
            .filter((col) => col.field !== "actions")
            .map((col) => (
              <div key={col.field} className="filter">
                <label>{col.headerName}</label>
                <input
                  type="text"
                  placeholder={`Filter by ${col.headerName}`}
                  value={filters[col.field] || ""}
                  onChange={(e) =>
                    handleFilterChange(col.field, e.target.value)
                  }
                  className="filter-input"
                />
              </div>
            ))}
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowFilterModal(false)}>
            Close
          </Button>
        </Modal.Footer>
      </Modal>
      {message && (
        <div
          className={`alert alert-${message.type} alert-dismissible fade show`}
          role="alert"
          style={{
            position: "fixed",
            bottom: "10px",
            margin: "10px",
            right: "10px",
            zIndex: "9999",
          }}
        >
          {message.text}
        </div>
      )}
    </div>
  );
}

export default InvoiceTable;
